import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icons from 'components/Icons';
import { useGame } from 'common/state';
import { getChart, getAttemptCount, getHintCount } from 'common/logic';
import { track } from 'common/analytics';
import { formatDate } from 'common/utils';

function ShareButton() {
  const { t } = useTranslation();
  const { language } = useParams();
  const [buttonText, setButtonText] = useState(t('shareButton.label'));
  const [gameState] = useGame();

  const isMobile = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

  const isFirefox = () =>
    navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;

  const displayFeedback = (text) => {
    setButtonText(text);
    setTimeout(() => {
      setButtonText(t('shareButton.label'));
    }, 2000);
  };

  const handleShareButton = () => {
    track.shareResults(gameState.id, language, gameState.mode);
    const attemptCount = getAttemptCount(gameState);
    const hintCount = getHintCount(gameState);
    const title =
      gameState.mode === 'unlimited'
        ? t('shareButton.unlimited')
        : formatDate(gameState.title, language);

    let text = `${t('shareButton.IPlayed')} ${title} ${t(
      'shareButton.andGotItIn',
    )} ${attemptCount} ${t('shareButton.guesses')}`;
    if (hintCount > 0) {
      text += ` ${t('shareButton.and')} ${hintCount} ${t('shareButton.hints', {
        count: hintCount,
      })}`;
    }
    text += '.\n\n';
    text += getChart(gameState);

    if (isMobile() && !isFirefox() && navigator.share) {
      navigator.share({ text }).then(() => {
        displayFeedback(t('shareButton.shared'));
      });
    } else {
      navigator.clipboard.writeText(text).then(() => {
        displayFeedback(t('shareButton.copied'));
      });
    }
  };

  return (
    <button className="button" onClick={handleShareButton}>
      <Icons.Share />
      <span>{buttonText}</span>
    </button>
  );
}

export default ShareButton;
